import type { PageBlockDefinition } from '../definition-types'

export const featureWithRailDefinition: PageBlockDefinition = {
  type: 'feature-with-rail',
  label: 'Feature with Rail',
  description: 'A dominant lead story anchored alongside supporting articles in a compact rail.',
  rowCompatible: true,
  columnCompatible: false,
  category: 'editorial',
  minArticles: 1,
  maxArticles: 6,
  slots: [
    { name: 'feature', label: 'Feature Article', required: true },
    { name: 'rail', label: 'Rail Articles (up to 5)', required: false },
  ],
  defaultConfig: {
    showImage: true,
    showSummary: true,
    supportingStyle: 'compact',
  },
  editorFields: [
    { key: 'showImage', label: 'Show Image', type: 'toggle' },
    { key: 'showSummary', label: 'Show Summary', type: 'toggle' },
    {
      key: 'supportingStyle',
      label: 'Supporting Style',
      type: 'select',
      options: [
        { label: 'Compact', value: 'compact' },
        { label: 'Teaser', value: 'teaser' },
      ],
    },
  ],
}
